import checkout from "./form";

const {
  formField: {
    period,
    exploitationDate,
    firstTime,
    additional,

    taxpayerName,
    dateOfBirth,
    taxId,
    identifier,
    dateRange,
    issuedBy,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    notificationAddress,
    phoneNumber,

    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,

    plotAddress,
    plotAddressCity,
    plotAddressDistrict,
    plotAddressWard,
    plotAddressVillage,
    plotAddressRoad,
    address,
    purposeOfUsingLand,
    acreage,
    startingTime,

    nonAgriculturalProductionBusiness,
    buildInfrastructure,
    buildIndustrial,
    agriculturalProduction,
    anotherPurpose,
    landUsePeriod,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [period.name]: "",
  [exploitationDate.name]: "",
  [firstTime.name]: "",
  [additional.name]: "",

  [taxpayerName.name]: "",
  [dateOfBirth.name]: "",
  [taxId.name]: "",
  [identifier.name]: "",
  [dateRange.name]: "",
  [issuedBy.name]: "",
  [city.name]: "",
  [district.name]: "",
  [ward.name]: "",
  [village.name]: "",
  [road.name]: "",
  [apartment.name]: "",
  [notificationAddress.name]: "",
  [phoneNumber.name]: "",

  [taxAgentName.name]: "",
  [taxAgentId.name]: "",
  [taxAgentContract.name]: "",
  [daytaxAgentContract.name]: "",

  [plotAddress.name]: "",
  [plotAddressCity.name]: "",
  [plotAddressDistrict.name]: "",
  [plotAddressWard.name]: "",
  [plotAddressVillage.name]: "",
  [plotAddressRoad.name]: "",
  [address.name]: "",
  [acreage.name]: "",
  [purposeOfUsingLand.name]: "",
  [startingTime.name]: "",

  [nonAgriculturalProductionBusiness.name]: "",
  [buildInfrastructure.name]: "",
  [buildIndustrial.name]: "",
  [agriculturalProduction.name]: "",
  [anotherPurpose.name]: "",
  [landUsePeriod.name]: "",

  [fullName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};
export default initialValues;
